module.exports = __webpack_public_path__ + "static/media/biggest-drops.7a6f044f.png";